/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { CustomerCaseDetails } from '../model/models';
import { CustomerCasePostPut } from '../model/models';
import { CustomerCaseResponse } from '../model/models';
import { CustomerCaseResponsePagingResult } from '../model/models';
import { CustomerCaseUserProductSelect } from '../model/models';
import { ECaseReason } from '../model/models';
import { ECaseStatus } from '../model/models';
import { ECurrency } from '../model/models';
import { EMainContact } from '../model/models';
import { EServicePlace } from '../model/models';
import { FilterCaseModel } from '../model/models';
import { PurchaseOrderPayment } from '../model/models';
import { PurchaseOrderPaymentIntentResponse } from '../model/models';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class CustomerCaseService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }

    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key,
                        (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Delete a specific case by caseId, allow for unsent status
     * @param caseId caseId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCustomerCasesByCaseIdDelete(caseId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public apiCustomerCasesByCaseIdDelete(caseId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public apiCustomerCasesByCaseIdDelete(caseId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public apiCustomerCasesByCaseIdDelete(caseId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {
        if (caseId === null || caseId === undefined) {
            throw new Error('Required parameter caseId was null or undefined when calling apiCustomerCasesByCaseIdDelete.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.delete<any>(`${this.configuration.basePath}/api/customerCases/${encodeURIComponent(String(caseId))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update an exist case from customer
     * @param caseId caseId
     * @param customerCasePostPut case info
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCustomerCasesByCaseIdPut(caseId: number, customerCasePostPut?: CustomerCasePostPut, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CustomerCaseResponse>;
    public apiCustomerCasesByCaseIdPut(caseId: number, customerCasePostPut?: CustomerCasePostPut, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CustomerCaseResponse>>;
    public apiCustomerCasesByCaseIdPut(caseId: number, customerCasePostPut?: CustomerCasePostPut, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CustomerCaseResponse>>;
    public apiCustomerCasesByCaseIdPut(caseId: number, customerCasePostPut?: CustomerCasePostPut, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (caseId === null || caseId === undefined) {
            throw new Error('Required parameter caseId was null or undefined when calling apiCustomerCasesByCaseIdPut.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<CustomerCaseResponse>(`${this.configuration.basePath}/api/customerCases/${encodeURIComponent(String(caseId))}`,
            customerCasePostPut,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCustomerCasesCheckTimeStampGet(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<any>;
    public apiCustomerCasesCheckTimeStampGet(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpResponse<any>>;
    public apiCustomerCasesCheckTimeStampGet(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined}): Observable<HttpEvent<any>>;
    public apiCustomerCasesCheckTimeStampGet(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<any>(`${this.configuration.basePath}/api/customerCases/checkTimeStamp`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create clientSecret for client
     * @param amount 
     * @param currency 
     * @param purchaseOrderId 
     * @param purchaseOrderCode 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCustomerCasesCreatePaymentIntentPost(amount: number, currency: ECurrency, purchaseOrderId?: number, purchaseOrderCode?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<PurchaseOrderPaymentIntentResponse>;
    public apiCustomerCasesCreatePaymentIntentPost(amount: number, currency: ECurrency, purchaseOrderId?: number, purchaseOrderCode?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<PurchaseOrderPaymentIntentResponse>>;
    public apiCustomerCasesCreatePaymentIntentPost(amount: number, currency: ECurrency, purchaseOrderId?: number, purchaseOrderCode?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<PurchaseOrderPaymentIntentResponse>>;
    public apiCustomerCasesCreatePaymentIntentPost(amount: number, currency: ECurrency, purchaseOrderId?: number, purchaseOrderCode?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (amount === null || amount === undefined) {
            throw new Error('Required parameter amount was null or undefined when calling apiCustomerCasesCreatePaymentIntentPost.');
        }
        if (currency === null || currency === undefined) {
            throw new Error('Required parameter currency was null or undefined when calling apiCustomerCasesCreatePaymentIntentPost.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (amount !== undefined && amount !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>amount, 'Amount');
        }
        if (currency !== undefined && currency !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>currency, 'Currency');
        }
        if (purchaseOrderId !== undefined && purchaseOrderId !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>purchaseOrderId, 'PurchaseOrderId');
        }
        if (purchaseOrderCode !== undefined && purchaseOrderCode !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>purchaseOrderCode, 'PurchaseOrderCode');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<PurchaseOrderPaymentIntentResponse>(`${this.configuration.basePath}/api/customerCases/createPaymentIntent`,
            null,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves case details by caseId
     * @param caseId caseId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCustomerCasesDetailsByCaseIdGet(caseId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CustomerCaseDetails>;
    public apiCustomerCasesDetailsByCaseIdGet(caseId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CustomerCaseDetails>>;
    public apiCustomerCasesDetailsByCaseIdGet(caseId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CustomerCaseDetails>>;
    public apiCustomerCasesDetailsByCaseIdGet(caseId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (caseId === null || caseId === undefined) {
            throw new Error('Required parameter caseId was null or undefined when calling apiCustomerCasesDetailsByCaseIdGet.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<CustomerCaseDetails>(`${this.configuration.basePath}/api/customerCases/details/${encodeURIComponent(String(caseId))}`,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param userProductId 
     * @param status 
     * @param reason 
     * @param servicePlace 
     * @param subject 
     * @param description 
     * @param contactInfoMainContact 
     * @param repairShopId 
     * @param photos 
     * @param contactInfoAddress 
     * @param contactInfoAddress2 
     * @param contactInfoCity 
     * @param contactInfoPostalCode 
     * @param contactInfoCountry 
     * @param contactInfoPhoneNumber 
     * @param errorTypeErrorTypeId 
     * @param errorTypeName 
     * @param errorTypeActive 
     * @param userAgent 
     * @param files 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCustomerCasesFormPost(userProductId: number, status: ECaseStatus, reason: ECaseReason, servicePlace: EServicePlace, subject: string, description: string, contactInfoMainContact: EMainContact, repairShopId?: number, photos?: Array<string>, contactInfoAddress?: string, contactInfoAddress2?: string, contactInfoCity?: string, contactInfoPostalCode?: string, contactInfoCountry?: string, contactInfoPhoneNumber?: string, errorTypeErrorTypeId?: number, errorTypeName?: string, errorTypeActive?: boolean, userAgent?: string, files?: Array<Blob>, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CustomerCaseResponse>;
    public apiCustomerCasesFormPost(userProductId: number, status: ECaseStatus, reason: ECaseReason, servicePlace: EServicePlace, subject: string, description: string, contactInfoMainContact: EMainContact, repairShopId?: number, photos?: Array<string>, contactInfoAddress?: string, contactInfoAddress2?: string, contactInfoCity?: string, contactInfoPostalCode?: string, contactInfoCountry?: string, contactInfoPhoneNumber?: string, errorTypeErrorTypeId?: number, errorTypeName?: string, errorTypeActive?: boolean, userAgent?: string, files?: Array<Blob>, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CustomerCaseResponse>>;
    public apiCustomerCasesFormPost(userProductId: number, status: ECaseStatus, reason: ECaseReason, servicePlace: EServicePlace, subject: string, description: string, contactInfoMainContact: EMainContact, repairShopId?: number, photos?: Array<string>, contactInfoAddress?: string, contactInfoAddress2?: string, contactInfoCity?: string, contactInfoPostalCode?: string, contactInfoCountry?: string, contactInfoPhoneNumber?: string, errorTypeErrorTypeId?: number, errorTypeName?: string, errorTypeActive?: boolean, userAgent?: string, files?: Array<Blob>, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CustomerCaseResponse>>;
    public apiCustomerCasesFormPost(userProductId: number, status: ECaseStatus, reason: ECaseReason, servicePlace: EServicePlace, subject: string, description: string, contactInfoMainContact: EMainContact, repairShopId?: number, photos?: Array<string>, contactInfoAddress?: string, contactInfoAddress2?: string, contactInfoCity?: string, contactInfoPostalCode?: string, contactInfoCountry?: string, contactInfoPhoneNumber?: string, errorTypeErrorTypeId?: number, errorTypeName?: string, errorTypeActive?: boolean, userAgent?: string, files?: Array<Blob>, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (userProductId === null || userProductId === undefined) {
            throw new Error('Required parameter userProductId was null or undefined when calling apiCustomerCasesFormPost.');
        }
        if (status === null || status === undefined) {
            throw new Error('Required parameter status was null or undefined when calling apiCustomerCasesFormPost.');
        }
        if (reason === null || reason === undefined) {
            throw new Error('Required parameter reason was null or undefined when calling apiCustomerCasesFormPost.');
        }
        if (servicePlace === null || servicePlace === undefined) {
            throw new Error('Required parameter servicePlace was null or undefined when calling apiCustomerCasesFormPost.');
        }
        if (subject === null || subject === undefined) {
            throw new Error('Required parameter subject was null or undefined when calling apiCustomerCasesFormPost.');
        }
        if (description === null || description === undefined) {
            throw new Error('Required parameter description was null or undefined when calling apiCustomerCasesFormPost.');
        }
        if (contactInfoMainContact === null || contactInfoMainContact === undefined) {
            throw new Error('Required parameter contactInfoMainContact was null or undefined when calling apiCustomerCasesFormPost.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: this.encoder});
        }

        if (userProductId !== undefined) {
            formParams = formParams.append('UserProductId', <any>userProductId) as any || formParams;
        }
        if (status !== undefined) {
            formParams = formParams.append('Status', <any>status) as any || formParams;
        }
        if (reason !== undefined) {
            formParams = formParams.append('Reason', <any>reason) as any || formParams;
        }
        if (servicePlace !== undefined) {
            formParams = formParams.append('ServicePlace', <any>servicePlace) as any || formParams;
        }
        if (repairShopId !== undefined) {
            formParams = formParams.append('RepairShopId', <any>repairShopId) as any || formParams;
        }
        if (subject !== undefined) {
            formParams = formParams.append('Subject', <any>subject) as any || formParams;
        }
        if (description !== undefined) {
            formParams = formParams.append('Description', <any>description) as any || formParams;
        }
        if (photos) {
            if (useForm) {
                photos.forEach((element) => {
                    formParams = formParams.append('Photos', <any>element) as any || formParams;
            })
            } else {
                formParams = formParams.append('Photos', photos.join(COLLECTION_FORMATS['csv'])) as any || formParams;
            }
        }
        if (contactInfoMainContact !== undefined) {
            formParams = formParams.append('ContactInfo.MainContact', <any>contactInfoMainContact) as any || formParams;
        }
        if (contactInfoAddress !== undefined) {
            formParams = formParams.append('ContactInfo.Address', <any>contactInfoAddress) as any || formParams;
        }
        if (contactInfoAddress2 !== undefined) {
            formParams = formParams.append('ContactInfo.Address2', <any>contactInfoAddress2) as any || formParams;
        }
        if (contactInfoCity !== undefined) {
            formParams = formParams.append('ContactInfo.City', <any>contactInfoCity) as any || formParams;
        }
        if (contactInfoPostalCode !== undefined) {
            formParams = formParams.append('ContactInfo.PostalCode', <any>contactInfoPostalCode) as any || formParams;
        }
        if (contactInfoCountry !== undefined) {
            formParams = formParams.append('ContactInfo.Country', <any>contactInfoCountry) as any || formParams;
        }
        if (contactInfoPhoneNumber !== undefined) {
            formParams = formParams.append('ContactInfo.PhoneNumber', <any>contactInfoPhoneNumber) as any || formParams;
        }
        if (errorTypeErrorTypeId !== undefined) {
            formParams = formParams.append('ErrorType.ErrorTypeId', <any>errorTypeErrorTypeId) as any || formParams;
        }
        if (errorTypeName !== undefined) {
            formParams = formParams.append('ErrorType.Name', <any>errorTypeName) as any || formParams;
        }
        if (errorTypeActive !== undefined) {
            formParams = formParams.append('ErrorType.Active', <any>errorTypeActive) as any || formParams;
        }
        if (userAgent !== undefined) {
            formParams = formParams.append('UserAgent', <any>userAgent) as any || formParams;
        }
        if (files) {
            if (useForm) {
                files.forEach((element) => {
                    formParams = formParams.append('Files', <any>element) as any || formParams;
            })
            } else {
                formParams = formParams.append('Files', files.join(COLLECTION_FORMATS['csv'])) as any || formParams;
            }
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<CustomerCaseResponse>(`${this.configuration.basePath}/api/customerCases/Form`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves cases of current user
     * @param filterCaseModel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCustomerCasesGet(filterCaseModel?: FilterCaseModel, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CustomerCaseResponsePagingResult>;
    public apiCustomerCasesGet(filterCaseModel?: FilterCaseModel, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CustomerCaseResponsePagingResult>>;
    public apiCustomerCasesGet(filterCaseModel?: FilterCaseModel, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CustomerCaseResponsePagingResult>>;
    public apiCustomerCasesGet(filterCaseModel?: FilterCaseModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<CustomerCaseResponsePagingResult>(`${this.configuration.basePath}/api/customerCases/getList`,
            filterCaseModel,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param productModel 
     * @param repairShopId 
     * @param subject 
     * @param description 
     * @param errorTypeId 
     * @param phoneNumber 
     * @param userAgent 
     * @param files 
     * @param address 
     * @param city 
     * @param postalCode 
     * @param country 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCustomerCasesOutOfWarrantyPost(productModel?: string, repairShopId?: number, subject?: string, description?: string, errorTypeId?: number, phoneNumber?: string, userAgent?: string, files?: Array<Blob>, address?: string, city?: string, postalCode?: string, country?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<boolean>;
    public apiCustomerCasesOutOfWarrantyPost(productModel?: string, repairShopId?: number, subject?: string, description?: string, errorTypeId?: number, phoneNumber?: string, userAgent?: string, files?: Array<Blob>, address?: string, city?: string, postalCode?: string, country?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<boolean>>;
    public apiCustomerCasesOutOfWarrantyPost(productModel?: string, repairShopId?: number, subject?: string, description?: string, errorTypeId?: number, phoneNumber?: string, userAgent?: string, files?: Array<Blob>, address?: string, city?: string, postalCode?: string, country?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<boolean>>;
    public apiCustomerCasesOutOfWarrantyPost(productModel?: string, repairShopId?: number, subject?: string, description?: string, errorTypeId?: number, phoneNumber?: string, userAgent?: string, files?: Array<Blob>, address?: string, city?: string, postalCode?: string, country?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: this.encoder});
        }

        if (productModel !== undefined) {
            formParams = formParams.append('ProductModel', <any>productModel) as any || formParams;
        }
        if (repairShopId !== undefined) {
            formParams = formParams.append('RepairShopId', <any>repairShopId) as any || formParams;
        }
        if (subject !== undefined) {
            formParams = formParams.append('Subject', <any>subject) as any || formParams;
        }
        if (description !== undefined) {
            formParams = formParams.append('Description', <any>description) as any || formParams;
        }
        if (errorTypeId !== undefined) {
            formParams = formParams.append('ErrorTypeId', <any>errorTypeId) as any || formParams;
        }
        if (phoneNumber !== undefined) {
            formParams = formParams.append('PhoneNumber', <any>phoneNumber) as any || formParams;
        }
        if (userAgent !== undefined) {
            formParams = formParams.append('UserAgent', <any>userAgent) as any || formParams;
        }
        if (files) {
            if (useForm) {
                files.forEach((element) => {
                    formParams = formParams.append('Files', <any>element) as any || formParams;
            })
            } else {
                formParams = formParams.append('Files', files.join(COLLECTION_FORMATS['csv'])) as any || formParams;
            }
        }
        if (address !== undefined) {
            formParams = formParams.append('Address', <any>address) as any || formParams;
        }
        if (city !== undefined) {
            formParams = formParams.append('City', <any>city) as any || formParams;
        }
        if (postalCode !== undefined) {
            formParams = formParams.append('PostalCode', <any>postalCode) as any || formParams;
        }
        if (country !== undefined) {
            formParams = formParams.append('Country', <any>country) as any || formParams;
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<boolean>(`${this.configuration.basePath}/api/customerCases/OutOfWarranty`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Pay for purchase order
     * @param purchaseOrderPayment amount, PO.ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCustomerCasesPayPurchaseOrderPut(purchaseOrderPayment?: PurchaseOrderPayment, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CustomerCaseDetails>;
    public apiCustomerCasesPayPurchaseOrderPut(purchaseOrderPayment?: PurchaseOrderPayment, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CustomerCaseDetails>>;
    public apiCustomerCasesPayPurchaseOrderPut(purchaseOrderPayment?: PurchaseOrderPayment, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CustomerCaseDetails>>;
    public apiCustomerCasesPayPurchaseOrderPut(purchaseOrderPayment?: PurchaseOrderPayment, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<CustomerCaseDetails>(`${this.configuration.basePath}/api/customerCases/payPurchaseOrder`,
            purchaseOrderPayment,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new case from customer
     * @param customerCasePostPut case info
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCustomerCasesPost(customerCasePostPut?: CustomerCasePostPut, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CustomerCaseResponse>;
    public apiCustomerCasesPost(customerCasePostPut?: CustomerCasePostPut, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CustomerCaseResponse>>;
    public apiCustomerCasesPost(customerCasePostPut?: CustomerCasePostPut, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CustomerCaseResponse>>;
    public apiCustomerCasesPost(customerCasePostPut?: CustomerCasePostPut, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<CustomerCaseResponse>(`${this.configuration.basePath}/api/customerCases`,
            customerCasePostPut,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Send case to SP
     * @param caseId caseId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCustomerCasesSendCaseByCaseIdPut(caseId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CustomerCaseResponse>;
    public apiCustomerCasesSendCaseByCaseIdPut(caseId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CustomerCaseResponse>>;
    public apiCustomerCasesSendCaseByCaseIdPut(caseId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CustomerCaseResponse>>;
    public apiCustomerCasesSendCaseByCaseIdPut(caseId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (caseId === null || caseId === undefined) {
            throw new Error('Required parameter caseId was null or undefined when calling apiCustomerCasesSendCaseByCaseIdPut.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.put<CustomerCaseResponse>(`${this.configuration.basePath}/api/customerCases/sendCase/${encodeURIComponent(String(caseId))}`,
            null,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves products belong to current user
     * @param isNewBikeOnly 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiCustomerCasesUserProductSelectGet(isNewBikeOnly?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<Array<CustomerCaseUserProductSelect>>;
    public apiCustomerCasesUserProductSelectGet(isNewBikeOnly?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<Array<CustomerCaseUserProductSelect>>>;
    public apiCustomerCasesUserProductSelectGet(isNewBikeOnly?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<Array<CustomerCaseUserProductSelect>>>;
    public apiCustomerCasesUserProductSelectGet(isNewBikeOnly?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if (isNewBikeOnly !== undefined && isNewBikeOnly !== null) {
          queryParameters = this.addToHttpParams(queryParameters,
            <any>isNewBikeOnly, 'isNewBikeOnly');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.get<Array<CustomerCaseUserProductSelect>>(`${this.configuration.basePath}/api/customerCases/userProductSelect`,
            {
                params: queryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves cases of Customer
     * @param customerId 
     * @param filterCaseModel 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiListCustomerCasesGet(customerId: number, filterCaseModel?: FilterCaseModel, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<CustomerCaseResponsePagingResult>;
    public apiListCustomerCasesGet(customerId: number, filterCaseModel?: FilterCaseModel, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpResponse<CustomerCaseResponsePagingResult>>;
    public apiListCustomerCasesGet(customerId: number, filterCaseModel?: FilterCaseModel, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json'}): Observable<HttpEvent<CustomerCaseResponsePagingResult>>;
    public apiListCustomerCasesGet(customerId: number, filterCaseModel?: FilterCaseModel, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json'}): Observable<any> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling apiListCustomerCasesGet.');
        }

        let headers = this.defaultHeaders;

        let credential: string | undefined;
        // authentication (Bearer) required
        credential = this.configuration.lookupCredential('Bearer');
        if (credential) {
            headers = headers.set('Authorization', credential);
        }

        let httpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (httpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' = 'json';
        if(httpHeaderAcceptSelected && httpHeaderAcceptSelected.startsWith('text')) {
            responseType_ = 'text';
        }

        return this.httpClient.post<CustomerCaseResponsePagingResult>(`${this.configuration.basePath}/api/customerCases/getListCustomerCase/${encodeURIComponent(String(customerId))}`,
            filterCaseModel,
            {
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
